import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { BsPlusLg, BsSkipBackward, BsSkipForward } from 'react-icons/bs';
import { useState, useEffect } from 'react';

const DetailsView = ({ show,
    handleCloseModal,
    handlePrevious,
    handleNext,
    filteredMenuList,
    selectedItemIndex,
    onAddToOrder,
    menuList,
    reviews,
    updateReview,
    removeReview,
    inReviewMode }) => {

    const [review, setReview] = useState({});

    useEffect(() => {
        const r = reviews.find(review => review.productNumber === filteredMenuList[selectedItemIndex].productNumber);
        if (r) {
            setReview(r);
        } else {
            setReview({ productNumber: filteredMenuList[selectedItemIndex].productNumber, comment: '', rating: 0 });
        }
    }, [selectedItemIndex, reviews]);

    const handleReviewCommentUpdate = (review, comment) => {
        let cpReview = JSON.parse(JSON.stringify(review));
        cpReview.comment = comment;
        setReview(cpReview);
    }

    const handleReviewRatingUpdate = (review, rating) => {
        let cpReview = JSON.parse(JSON.stringify(review));
        cpReview.rating = rating;
        setReview(cpReview);
    }

    const handleUpdateReview = (review) => {
        if (review.rating === 0) {
            alert('geef aub een sterren-rating van minimum 1 ster');
            return;
        }
        updateReview(review);
        handleCloseModal();
    }

    const handleRemoveReview = (review) => {
        if (!window.confirm('Weet je zeker dat je deze review wilt verwijderen?')) {
            return;
        }
        removeReview(review);
        handleCloseModal();
    }

    return (
        <Modal show={show} backdrop="static" onHide={handleCloseModal}>
            <Modal.Header closeButton>
                <Button variant="primary" onClick={handlePrevious}>
                    <BsSkipBackward />
                </Button>
                ||
                <Button variant="primary" onClick={handleNext}>
                    <BsSkipForward />
                </Button>
                <Modal.Title>{filteredMenuList[selectedItemIndex].productNumber} - {menuList[selectedItemIndex].productName}
                </Modal.Title>
            </Modal.Header>
            {!inReviewMode ? (
                <div>
                    <Modal.Body>{filteredMenuList[selectedItemIndex].description}</Modal.Body>
                    <Modal.Footer>
                        {filteredMenuList[selectedItemIndex].outOfStock === 'True' ? <span className="badge bg-danger">Uitverkocht</span> : <Button variant="success" onClick={() => onAddToOrder(menuList[selectedItemIndex])}>
                            <BsPlusLg /> Voeg toe
                        </Button>}
                        <Button variant="secondary" onClick={handleCloseModal}>
                            Close
                        </Button>
                    </Modal.Footer>
                </div>
            ) : (
                <div>
                    <Modal.Body>
                        <form>
                            <div className="mb-3">
                                <label htmlFor="comment" className="form-label">Comment</label>
                                <textarea
                                    className="form-control"
                                    id="comment"
                                    rows="3"
                                    value={review.comment}
                                    onChange={(e) => handleReviewCommentUpdate(review, e.target.value)}
                                ></textarea>
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Rating</label>
                                <div>
                                    {[1, 2, 3, 4, 5].map(star => (
                                        <span
                                            key={star}
                                            className={`star ${star <= review.rating ? 'selected' : ''}`}
                                            onClick={() => handleReviewRatingUpdate(review, star)}
                                            style={{ cursor: 'pointer', fontSize: '1.5rem', color: star <= review.rating ? 'gold' : 'gray' }}
                                        >
                                            ★
                                        </span>
                                    ))}
                                </div>
                            </div>
                        </form>
                    </Modal.Body>
                    <Modal.Footer className="d-flex justify-content-between">
                        <Button variant="secondary" onClick={handleCloseModal}>
                            Annuleer
                        </Button>
                        <Button variant="danger" onClick={() => handleRemoveReview(review)}>
                            Verwijder
                        </Button>
                        <Button variant="primary" onClick={() => handleUpdateReview(review)}>
                            Verstuur
                        </Button>
                    </Modal.Footer>
                </div>
            )}
        </Modal>
    );
};

export default DetailsView;